import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SystemService {
  private baseUrl = environment.beServiceUrl;

  constructor(private http: HttpClient) {}

  getMonitoring() {
    return this.http.get<any>(this.baseUrl + '/v1/monitoring');
  }

}
